module.exports = __webpack_public_path__ + "static/dinosaurbathmain-236727f2e3f36fc7a78743b9445aba96.png";